import React, { useState } from 'react';
import { RecycleIcon, Trash2Icon, ShoppingCartIcon, LeafIcon, MoreVerticalIcon, ChevronsLeftIcon, ChevronLeftIcon, ChevronRightIcon, ChevronsRightIcon, CalendarIcon, ClockIcon, ChevronDownIcon } from 'lucide-react';
interface Collecte {
  id: string;
  nom: string;
  zones: string;
  journees: string;
  frequence: string;
  couleur: string;
  icone: string;
}
const INITIAL_COLLECTES: Collecte[] = [{
  id: '1',
  nom: 'Récupération',
  zones: 'Secteurs A-B-E',
  journees: 'Lundi, Mardi, Mercredi, Jeudi, Vendredi, Samedi, Dimanche',
  frequence: 'Chaque semaine',
  couleur: 'bg-blue-500',
  icone: 'recycle'
}, {
  id: '2',
  nom: 'Résidus alimentaires',
  zones: 'Secteurs C-I-J-L-M-X-Y',
  journees: 'Lundi, Mardi, Mercredi, Jeudi, Vendredi, Samedi, Dimanche',
  frequence: 'Chaque semaine',
  couleur: 'bg-purple-500',
  icone: 'trash'
}, {
  id: '3',
  nom: 'Encombrants de bois valorisables',
  zones: 'Secteurs N-O-S',
  journees: 'Lundi, Mardi, Mercredi, Jeudi, Vendredi, Samedi, Dimanche',
  frequence: 'Chaque semaine',
  couleur: 'bg-lime-400',
  icone: 'cart'
}, {
  id: '4',
  nom: 'Résidus verts',
  zones: 'Secteurs P-R-T-V',
  journees: 'Lundi, Mardi, Mercredi, Jeudi, Vendredi, Samedi, Dimanche',
  frequence: 'Chaque semaine',
  couleur: 'bg-rose-500',
  icone: 'leaf'
}];
const DAYS = ['L', 'M', 'M', 'J', 'V', 'S', 'D'];
export function CollectesGerer() {
  const [view, setView] = useState<'list' | 'form'>('list');
  const [collectes, setCollectes] = useState<Collecte[]>(INITIAL_COLLECTES);
  const [editingCollecte, setEditingCollecte] = useState<Collecte | null>(null);
  const [openMenuId, setOpenMenuId] = useState<string | null>(null);
  // Form State
  const [formNomFr, setFormNomFr] = useState('');
  const [formNomAn, setFormNomAn] = useState('');
  const [formCouleur, setFormCouleur] = useState('bg-green-500');
  const [formIcone, setFormIcone] = useState('trash');
  const [formForme, setFormForme] = useState('circle');
  const [formZone, setFormZone] = useState('Non sélectionné');
  const [formDateDebut, setFormDateDebut] = useState('');
  const [formDateFin, setFormDateFin] = useState('');
  const [formHeureDebut, setFormHeureDebut] = useState('--:--');
  const [formFrequence, setFormFrequence] = useState('Sélectionnez une fréquence');
  const [formDays, setFormDays] = useState<string[]>([]);
  const [customPeriods, setCustomPeriods] = useState<any[]>([]);
  const getIcon = (name: string, className = 'w-5 h-5') => {
    switch (name) {
      case 'recycle':
        return <RecycleIcon className={className} data-id="element-1488" data-mp="1xd0z5q85uldk" />;
      case 'trash':
        return <Trash2Icon className={className} data-id="element-1489" data-mp="22aj1gxroa2cl" />;
      case 'cart':
        return <ShoppingCartIcon className={className} data-id="element-1490" data-mp="26cxl3k36164x" />;
      case 'leaf':
        return <LeafIcon className={className} data-id="element-1491" data-mp="26auk650h5slf" />;
      default:
        return <Trash2Icon className={className} data-id="element-1492" data-mp="3dpzb5w4w5u1o" />;
    }
  };
  const handleCreateNew = () => {
    setEditingCollecte(null);
    setFormNomFr('');
    setFormNomAn('');
    setFormCouleur('bg-green-500');
    setFormIcone('trash');
    setFormForme('circle');
    setFormZone('Non sélectionné');
    setFormDateDebut('');
    setFormDateFin('');
    setFormHeureDebut('--:--');
    setFormFrequence('Sélectionnez une fréquence');
    setFormDays([]);
    setCustomPeriods([]);
    setView('form');
  };
  const handleEdit = (collecte: Collecte) => {
    setEditingCollecte(collecte);
    setFormNomFr(collecte.nom);
    setFormNomAn('');
    setFormCouleur(collecte.couleur);
    setFormIcone(collecte.icone);
    setFormForme('circle');
    setFormZone(collecte.zones);
    setFormDateDebut('');
    setFormDateFin('');
    setFormHeureDebut('--:--');
    setFormFrequence(collecte.frequence);
    setFormDays(['L', 'M', 'M', 'J', 'V', 'S', 'D']);
    setCustomPeriods([]);
    setView('form');
    setOpenMenuId(null);
  };
  const handleDelete = (id: string) => {
    setCollectes(collectes.filter(c => c.id !== id));
    setOpenMenuId(null);
  };
  const handleSave = () => {
    if (editingCollecte) {
      setCollectes(collectes.map(c => c.id === editingCollecte.id ? {
        ...c,
        nom: formNomFr || c.nom,
        couleur: formCouleur,
        icone: formIcone,
        zones: formZone !== 'Non sélectionné' ? formZone : c.zones,
        frequence: formFrequence !== 'Sélectionnez une fréquence' ? formFrequence : c.frequence
      } : c));
    } else {
      const newCollecte: Collecte = {
        id: Math.random().toString(36).substr(2, 9),
        nom: formNomFr || 'Nouvelle collecte',
        zones: formZone !== 'Non sélectionné' ? formZone : 'Toutes les zones',
        journees: 'Lundi, Mardi, Mercredi, Jeudi, Vendredi, Samedi, Dimanche',
        frequence: formFrequence !== 'Sélectionnez une fréquence' ? formFrequence : 'Chaque semaine',
        couleur: formCouleur,
        icone: formIcone
      };
      setCollectes([...collectes, newCollecte]);
    }
    setView('list');
  };
  const toggleDay = (day: string) => {
    if (formDays.includes(day)) {
      setFormDays(formDays.filter(d => d !== day));
    } else {
      setFormDays([...formDays, day]);
    }
  };
  if (view === 'form') {
    return <div className="space-y-8 animate-in fade-in duration-200" data-id="element-1493" data-mp="3be6xcz2on0qs">
        <div data-id="element-1494" data-mp="3qa4o21tu7cvm">
          <button onClick={() => setView('list')} className="text-sm text-slate-500 hover:text-slate-700 flex items-center gap-1 mb-4" data-id="element-1495" data-mp="3qaxut2ssq2dr">
            <ChevronLeftIcon className="w-4 h-4" data-id="element-1496" data-mp="34nfzdh4mh41" /> Collectes
          </button>
          <h2 className="text-2xl font-bold text-[#0F172A]" data-id="element-1497" data-mp="32kfu0m9f7ll">
            Créer une nouvelle collecte
          </h2>
        </div>

        {/* Information générale */}
        <section className="space-y-4" data-id="element-1498" data-mp="ct5dnlu4083g">
          <h3 className="text-lg font-semibold text-slate-900" data-id="element-1499" data-mp="cwb16wn3b1x2">
            Information générale
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1500" data-mp="lv4x0ksljo9k">
            <div data-id="element-1501" data-mp="lvelg3xztnd5">
              <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-1502" data-mp="lssd423a33tv">
                Nom FR
              </label>
              <input type="text" value={formNomFr} onChange={e => setFormNomFr(e.target.value)} placeholder="Nom de la collecte en Français" className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#4F46E5] focus:border-[#4F46E5]" data-id="element-1503" data-mp="ox9nlds64upz" />
            </div>
            <div data-id="element-1504" data-mp="13lw0z9y8jcek">
              <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-1505" data-mp="13mflmyf9sewa">
                Nom AN
              </label>
              <input type="text" value={formNomAn} onChange={e => setFormNomAn(e.target.value)} placeholder="Nom de la collecte en Anglais" className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#4F46E5] focus:border-[#4F46E5]" data-id="element-1506" data-mp="17mze3ooweuc3" />
            </div>
          </div>

          <div className="flex gap-4" data-id="element-1507" data-mp="3jcs15r7x115i">
            <div className="w-32" data-id="element-1508" data-mp="3jdtpuyhutm5p">
              <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-1509" data-mp="3jev0j1uyk6mw">
                Couleur
              </label>
              <div className="relative" data-id="element-1510" data-mp="25gqovix1rbm4">
                <select value={formCouleur} onChange={e => setFormCouleur(e.target.value)} className="w-full border border-slate-300 rounded-md pl-10 pr-8 py-2 text-sm appearance-none focus:outline-none focus:ring-1 focus:ring-[#4F46E5] focus:border-[#4F46E5]" data-id="element-1511" data-mp="25hjz4tv7sj90">
                  <option value="bg-green-500" data-id="element-1512" data-mp="1rply76bnptnx">Vert</option>
                  <option value="bg-blue-500" data-id="element-1513" data-mp="1rr6pmn2ocwhk">Bleu</option>
                  <option value="bg-purple-500" data-id="element-1514" data-mp="2ofwbeohfa98t">Violet</option>
                  <option value="bg-lime-400" data-id="element-1515" data-mp="2od9zydrev9lb">Lime</option>
                  <option value="bg-rose-500" data-id="element-1516" data-mp="2kfc9l7lwmhgc">Rose</option>
                </select>
                <div className="absolute left-3 top-1/2 -translate-y-1/2" data-id="element-1517" data-mp="2fdvdrqia1l6m">
                  <div className={`w-4 h-4 rounded-full ${formCouleur}`} data-id="element-1518" data-mp="2agd1pr8yqpue"></div>
                </div>
                <ChevronDownIcon className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" data-id="element-1519" data-mp="140ar773pr31c" />
              </div>
            </div>
            <div className="w-32" data-id="element-1520" data-mp="z31623ncxdjb">
              <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-1521" data-mp="2z2ei42yg2rdt">
                Icône
              </label>
              <div className="relative" data-id="element-1522" data-mp="342sgsue5ooz6">
                <select value={formIcone} onChange={e => setFormIcone(e.target.value)} className="w-full border border-slate-300 rounded-md pl-10 pr-8 py-2 text-sm appearance-none focus:outline-none focus:ring-1 focus:ring-[#4F46E5] focus:border-[#4F46E5]" data-id="element-1523" data-mp="33zo5ze66quzj">
                  <option value="trash" data-id="element-1524" data-mp="3huqgkelz98io">Poubelle</option>
                  <option value="recycle" data-id="element-1525" data-mp="3ms8vclmoehyl">Recyclage</option>
                  <option value="cart" data-id="element-1526" data-mp="3mrqnerqnifau">Chariot</option>
                  <option value="leaf" data-id="element-1527" data-mp="384e0ozp3y3iv">Feuille</option>
                </select>
                <div className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-600" data-id="element-1528" data-mp="3d2fizieplyta">
                  {getIcon(formIcone, 'w-4 h-4')}
                </div>
                <ChevronDownIcon className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" data-id="element-1529" data-mp="4lkp2sfw3orc" />
              </div>
            </div>
            <div className="w-32" data-id="element-1530" data-mp="1u2zhfbob7cjd">
              <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-1531" data-mp="1u26fqp47jd83">
                Forme
              </label>
              <div className="relative" data-id="element-1532" data-mp="23tuelb33fwjl">
                <select value={formForme} onChange={e => setFormForme(e.target.value)} className="w-full border border-slate-300 rounded-md pl-10 pr-8 py-2 text-sm appearance-none focus:outline-none focus:ring-1 focus:ring-[#4F46E5] focus:border-[#4F46E5]" data-id="element-1533" data-mp="23sss8agmnnmk">
                  <option value="circle" data-id="element-1534" data-mp="16627npe8hgyt">Cercle</option>
                  <option value="square" data-id="element-1535" data-mp="167n1fcsq4vvm">Carré</option>
                </select>
                <div className="absolute left-3 top-1/2 -translate-y-1/2" data-id="element-1536" data-mp="1k6wei3lmv9vd">
                  <div className={`w-4 h-4 bg-slate-800 ${formForme === 'circle' ? 'rounded-full' : 'rounded-sm'}`} data-id="element-1537" data-mp="1g3qdbaddo8vr"></div>
                </div>
                <ChevronDownIcon className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" data-id="element-1538" data-mp="2vjfepmdqdj3m" />
              </div>
            </div>
          </div>

          <div className="w-64" data-id="element-1539" data-mp="1pd3b9zbq7ms0">
            <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-1540" data-mp="1pghcv5ckfrye">
              Zone
            </label>
            <div className="relative" data-id="element-1541" data-mp="1gm329g2zd5lm">
              <select value={formZone} onChange={e => setFormZone(e.target.value)} className="w-full border border-slate-300 rounded-md px-3 py-2 pr-8 text-sm appearance-none focus:outline-none focus:ring-1 focus:ring-[#4F46E5] focus:border-[#4F46E5]" data-id="element-1542" data-mp="1gl1f4d8owsnj">
                <option data-id="element-1543" data-mp="16liz27vwhr0r">Non sélectionné</option>
                <option data-id="element-1544" data-mp="11nr7xg32y8xm">Secteurs A-B-E</option>
                <option data-id="element-1545" data-mp="11r57kgkd041d">Secteurs C-I-J-L-M-X-Y</option>
                <option data-id="element-1546" data-mp="xo05ug83s6ds">Secteurs N-O-S</option>
                <option data-id="element-1547" data-mp="so41ugzeoey8">Secteurs P-R-T-V</option>
              </select>
              <ChevronDownIcon className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" data-id="element-1548" data-mp="spyp41y5gj5h" />
            </div>
          </div>
        </section>

        {/* Période par défaut */}
        <section className="space-y-4" data-id="element-1549" data-mp="2n02eyu0u5uze">
          <h3 className="text-lg font-semibold text-slate-900" data-id="element-1550" data-mp="2umfxlz1nzflz">
            Période par défaut
          </h3>

          <div className="flex gap-4" data-id="element-1551" data-mp="2zjpjx5trbb5l">
            <div className="w-48 relative" data-id="element-1552" data-mp="2zio7oy108ima">
              <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-1553" data-mp="34axwgaqdvcmz">
                Date de début
              </label>
              <input type="text" placeholder="Date de début" value={formDateDebut} onChange={e => setFormDateDebut(e.target.value)} className="w-full border border-slate-300 rounded-md pl-3 pr-10 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#4F46E5] focus:border-[#4F46E5]" data-id="element-1554" data-mp="39a10brumnctd" />
              <CalendarIcon className="absolute right-3 top-[26px] w-4 h-4 text-slate-400" data-id="element-1555" data-mp="2lk6nhaab5o94" />
            </div>
            <div className="w-48 relative" data-id="element-1556" data-mp="2po4ojqj7194t">
              <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-1557" data-mp="uqymkung9m4">
                Date de fin
              </label>
              <input type="text" placeholder="Date de fin" value={formDateFin} onChange={e => setFormDateFin(e.target.value)} className="w-full border border-slate-300 rounded-md pl-3 pr-10 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#4F46E5] focus:border-[#4F46E5]" data-id="element-1558" data-mp="4vkmxfc07qfj" />
              <CalendarIcon className="absolute right-3 top-[26px] w-4 h-4 text-slate-400" data-id="element-1559" data-mp="2ay6ktem6woml" />
            </div>
            <div className="w-48 relative" data-id="element-1560" data-mp="25ybrz5iutoyw">
              <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-1561" data-mp="25zd7pnatezmy">
                Heure de début
              </label>
              <input type="text" placeholder="--:--" value={formHeureDebut} onChange={e => setFormHeureDebut(e.target.value)} className="w-full border border-slate-300 rounded-md pl-3 pr-10 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#4F46E5] focus:border-[#4F46E5]" data-id="element-1562" data-mp="1e7nsdxwtwrnc" />
              <ClockIcon className="absolute right-3 top-[26px] w-4 h-4 text-slate-400" data-id="element-1563" data-mp="1n697fj33dojd" />
            </div>
          </div>

          <div className="w-64" data-id="element-1564" data-mp="ujy96f2yjzpq">
            <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-1565" data-mp="uin6yjp5v00q">
              Fréquence
            </label>
            <div className="relative" data-id="element-1566" data-mp="365gtrr9wctex">
              <select value={formFrequence} onChange={e => setFormFrequence(e.target.value)} className="w-full border border-slate-300 rounded-md px-3 py-2 pr-8 text-sm appearance-none focus:outline-none focus:ring-1 focus:ring-[#4F46E5] focus:border-[#4F46E5]" data-id="element-1567" data-mp="3ax8gtrtugh0b">
                <option data-id="element-1568" data-mp="3232flkh6ahtz">Sélectionnez une fréquence</option>
                <option data-id="element-1569" data-mp="3pvsplo5imr1m">Chaque semaine</option>
                <option data-id="element-1570" data-mp="3pswqhwhxlwbl">Aux deux semaines</option>
                <option data-id="element-1571" data-mp="3tvb7eb21im08">Chaque mois</option>
              </select>
              <ChevronDownIcon className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" data-id="element-1572" data-mp="3fwtp4suwm1pp" />
            </div>
          </div>

          <div data-id="element-1573" data-mp="3kttko9u4nm2k">
            <label className="block text-xs font-medium text-slate-500 mb-2" data-id="element-1574" data-mp="3kxhdf6rr04g8">
              Répéter le
            </label>
            <div className="flex gap-2" data-id="element-1575" data-mp="29g7y8wfnjykq">
              {DAYS.map(day => <button key={day} onClick={() => toggleDay(day)} className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-medium transition-colors ${formDays.includes(day) ? 'bg-[#4F46E5] text-white' : 'bg-slate-100 text-slate-600 hover:bg-slate-200'}`} data-id="element-1576" data-mp="29hsrmiq8dbh0">
                  {day}
                </button>)}
            </div>
          </div>
        </section>

        {/* Périodes personnalisées */}
        <section className="space-y-4" data-id="element-1577" data-mp="2awwswf2n9suq">
          <h3 className="text-lg font-semibold text-slate-900" data-id="element-1578" data-mp="37pa5v8zd7fxj">
            Périodes personnalisées
          </h3>
          <p className="text-sm text-slate-500" data-id="element-1579" data-mp="33oq8q5eskcbe">
            S'il y a une période pendant laquelle cette collecte aura lieu un
            jour différent, vous pouvez la définir ici. Vous pouvez ajouter
            autant de périodes personnalisées que nécessaire.
          </p>
          <button onClick={() => setCustomPeriods([...customPeriods, {}])} className="border border-[#4F46E5] text-[#4F46E5] px-4 py-2 rounded-md text-sm font-medium hover:bg-indigo-50 transition-colors" data-id="element-1580" data-mp="1n9f7d19z3r07">
            Ajouter une période personnalisée
          </button>
        </section>

        <div className="flex justify-end gap-4 pt-8" data-id="element-1581" data-mp="1d4p0qi3mjypn">
          <button onClick={() => setView('list')} className="border border-slate-300 text-slate-700 px-6 py-2 rounded-lg text-sm font-medium hover:bg-slate-50 transition-colors" data-id="element-1582" data-mp="1d5i2t5rn201g">
            Annuler
          </button>
          <button onClick={handleSave} className="bg-[#4F46E5] text-white px-6 py-2 rounded-lg text-sm font-medium hover:bg-[#4338CA] transition-colors" data-id="element-1583" data-mp="1mwuunxdfsq7h">
            Sauvegarder
          </button>
        </div>
      </div>;
  }
  // List View
  return <div className="space-y-6" data-id="element-1584" data-mp="20vufsv1qqmyw">
      <div className="flex justify-end mb-6" data-id="element-1585" data-mp="20vkmoylefzoz">
        <button onClick={handleCreateNew} className="bg-[#4F46E5] text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-[#4338CA] transition-colors" data-id="element-1586" data-mp="25ufgevkwn8nv">
          Ajouter une collecte
        </button>
      </div>

      <div className="bg-white border border-slate-200 rounded-xl overflow-hidden" data-id="element-1587" data-mp="bgwdt7c0ozvp">
        <div className="overflow-x-auto" data-id="element-1588" data-mp="3enghg1cad29">
          <table className="w-full text-sm text-left" data-id="element-1589" data-mp="3ffawnj7a4qy">
            <thead className="bg-slate-50 border-b border-slate-200" data-id="element-1590" data-mp="3ulzzm0ls90kt">
              <tr data-id="element-1591" data-mp="ddcwt4dl7pge">
                <th className="px-4 py-3 w-12" data-id="element-1592" data-mp="ddw4ls9iwxgp"></th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wide cursor-pointer hover:bg-slate-100" data-id="element-1593" data-mp="deo2j9qlf7a5">
                  <div className="flex items-center gap-1" data-id="element-1594" data-mp="mdj4uaqinx86">
                    Nom <ChevronDownIcon className="w-3 h-3 text-slate-400" data-id="element-1595" data-mp="mbokoyn2k955" />
                  </div>
                </th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wide cursor-pointer hover:bg-slate-100" data-id="element-1596" data-mp="w3ujosbqnqtu">
                  <div className="flex items-center gap-1" data-id="element-1597" data-mp="r62mpjw8leis">
                    Zones <ChevronDownIcon className="w-3 h-3 text-slate-400" data-id="element-1598" data-mp="1540x6e7fsqt0" />
                  </div>
                </th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wide cursor-pointer hover:bg-slate-100" data-id="element-1599" data-mp="113yrzv2htf8z">
                  <div className="flex items-center gap-1" data-id="element-1600" data-mp="1jpes4e0f5s78">
                    Journées{' '}
                    <ChevronDownIcon className="w-3 h-3 text-slate-400" data-id="element-1601" data-mp="1onyeugmu780n" />
                  </div>
                </th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wide cursor-pointer hover:bg-slate-100" data-id="element-1602" data-mp="1fpmhlvrgtbz8">
                  <div className="flex items-center gap-1" data-id="element-1603" data-mp="10zyfisbgm9ag">
                    Fréquence{' '}
                    <ChevronDownIcon className="w-3 h-3 text-slate-400" data-id="element-1604" data-mp="15s8a4lnirxj2" />
                  </div>
                </th>
                <th className="px-4 py-3 w-12" data-id="element-1605" data-mp="s1wfog3gpmor"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-1606" data-mp="w26khpfiq721">
              {collectes.map(collecte => <tr key={collecte.id} className="hover:bg-slate-50" data-id="element-1607" data-mp="i36x0l3qry7g">
                  <td className="px-4 py-4" data-id="element-1608" data-mp="n1i80z5rwer9">
                    <div className={`w-4 h-4 rounded-full ${collecte.couleur}`} data-id="element-1609" data-mp="n0fe0id5lw74"></div>
                  </td>
                  <td className="px-4 py-4" data-id="element-1610" data-mp="12i6z0py6bmxu">
                    <div className="flex items-center gap-3" data-id="element-1611" data-mp="xjdp17i3ie2f">
                      <div className="text-slate-600" data-id="element-1612" data-mp="xhsvnl7ip165">
                        {getIcon(collecte.icone)}
                      </div>
                      <button onClick={() => handleEdit(collecte)} className="text-[#4F46E5] font-medium hover:underline text-left" data-id="element-1613" data-mp="ojqjqam8wo43">
                        {collecte.nom}
                      </button>
                    </div>
                  </td>
                  <td className="px-4 py-4 text-slate-600" data-id="element-1614" data-mp="es30gwzueddp">{collecte.zones}</td>
                  <td className="px-4 py-4 text-slate-600" data-id="element-1615" data-mp="9v48ajzqogi5">
                    {collecte.journees}
                  </td>
                  <td className="px-4 py-4 text-slate-600" data-id="element-1616" data-mp="5uk6h3480opo">
                    {collecte.frequence}
                  </td>
                  <td className="px-4 py-4 relative" data-id="element-1617" data-mp="3rzxm8dsxcfba">
                    <button onClick={() => setOpenMenuId(openMenuId === collecte.id ? null : collecte.id)} className="text-slate-400 hover:text-slate-600 p-1 rounded-full hover:bg-slate-100" aria-label="Actions" data-id="element-1618" data-mp="3s0ft04d7qbxg">
                      <MoreVerticalIcon className="w-5 h-5" data-id="element-1619" data-mp="2cf56jw2ogca7" />
                    </button>
                    {openMenuId === collecte.id && <>
                        <div className="fixed inset-0 z-10" onClick={() => setOpenMenuId(null)} data-id="element-1620" data-mp="2li69jnw8xn9n"></div>
                        <div className="absolute right-8 top-10 w-32 bg-white rounded-md shadow-lg border border-slate-200 z-20 py-1" data-id="element-1621" data-mp="1orxa83n88dkb">
                          <button onClick={() => handleEdit(collecte)} className="w-full text-left px-4 py-2 text-sm text-slate-700 hover:bg-slate-50" data-id="element-1622" data-mp="1tr04qu5kz1e1">
                            Modifier
                          </button>
                          <button onClick={() => handleDelete(collecte.id)} className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-slate-50" data-id="element-1623" data-mp="22kwmzxvmjto6">
                            Supprimer
                          </button>
                        </div>
                      </>}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {/* Pagination Footer */}
        <div className="border-t border-slate-200 px-4 py-3 flex items-center justify-end gap-6 bg-white text-sm text-slate-500" data-id="element-1624" data-mp="mhz53zeoj1hg">
          <div className="flex items-center gap-2" data-id="element-1625" data-mp="vhccmmj8tfzj">
            <span data-id="element-1626" data-mp="veq86vrnfglj">Éléments par page</span>
            <select className="border-b border-slate-300 bg-transparent py-1 pr-4 focus:outline-none focus:border-[#4F46E5] appearance-none" data-id="element-1627" data-mp="3uwhgob3twz5t">
              <option data-id="element-1628" data-mp="2sorqs2eosmi">10</option>
              <option data-id="element-1629" data-mp="7r8c4o1cpwcr">20</option>
              <option data-id="element-1630" data-mp="7qzw4n9xmaxc">50</option>
            </select>
          </div>
          <div data-id="element-1631" data-mp="chyhw2dow17z">
            1 - {collectes.length} / {collectes.length}
          </div>
          <div className="flex items-center gap-2" data-id="element-1632" data-mp="cjt5jogci7fr">
            <button className="p-1 text-slate-300 cursor-not-allowed" data-id="element-1633" data-mp="3b6x891rnlsyb">
              <ChevronsLeftIcon className="w-4 h-4" data-id="element-1634" data-mp="3g6jnfgr1lj9r" />
            </button>
            <button className="p-1 text-slate-300 cursor-not-allowed" data-id="element-1635" data-mp="3g4p2w3jont67">
              <ChevronLeftIcon className="w-4 h-4" data-id="element-1636" data-mp="38mr7t4290kmi" />
            </button>
            <button className="p-1 text-slate-300 cursor-not-allowed" data-id="element-1637" data-mp="33phbd4gfz8p6">
              <ChevronRightIcon className="w-4 h-4" data-id="element-1638" data-mp="2yp30zfrdbmnz" />
            </button>
            <button className="p-1 text-slate-300 cursor-not-allowed" data-id="element-1639" data-mp="2yr7d2kzf7rzc">
              <ChevronsRightIcon className="w-4 h-4" data-id="element-1640" data-mp="2un7yw91m5595" />
            </button>
          </div>
        </div>
      </div>
    </div>;
}